import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { SocoHttpService, ApiResult } from '@app/base/soco';
import { HomeTabsEnum, HomeSubtabsEnum, RequestServiceModel } from '@app/base/core';
import { GasAvailabilityLetterModel } from '@app/base/shared/models/letter.model';
import { MeterActivateModel } from '@app/modules/builder/base/models';
import { BCASearch, BuilderInfo, Gasbca, BuilderInfoOne, GasApplianceModel } from '@app/base/core/models';
import { GasRequestModel } from '@app/shared/models/applicant/new.model';
import { BuilderLoginAuditModel } from '../../../../base/core/models/app/builder.login.audit.model';
@Injectable({
  providedIn: 'root'
})
export class BuilderService {
  public activeMainTab: number = HomeTabsEnum.Requests;
  public activeSubTab: number = HomeSubtabsEnum.Subdivision;
  public routeFlag: number;
  public reassigmentFlag: number;
  public gid: number;
  public lotnum: any;
  public subsidiaryId: any = {};
  public individualServiceClicked: any = false;
  public builderInfo: BuilderInfo = {
    Admin: false,
    BuilderId: [],
    subsidiaryId: [],
    subsidiaryList: [],
    CompanyName: '',
    IsActive: '',
    CompanyAddress: {
      id: '',
      contactTypeCode: '',
      streetNumber: '',
      recUpdatedDate: '',
    recCreatedDate: '',
    recCreatedBy: '',
    recUpdatedBy: '',
      streetName: '',
      directionPrefix: '',
      directionSuffix: '',
      streetType: '',
      city: '',
      state: '',
      zipCode: '',
      contactName2Extn: '',
      contactName1Extn: '',
      contactName1Phone: '',
      contactName1AreaCode: '',
      contactName2AreaCode: '',
      contactName2Phone: '',
      address2: '',
      unitNumber: '',
    },
    CompanyEmail: '',
   // AdminUsers: [{ firstName: '', lastName: '', userId: '', builderId: '', email: '' }],
    BuilderMapping: [{ id: '', builderName: '', subsidiaryId: [], subsidiaryName: [], status: '' }]
  };
  public builderInfoSub: BuilderInfo = {
    Admin: false,
    BuilderId: [],
    subsidiaryId: [],
    subsidiaryList: [],
    CompanyName: null,
    IsActive: null,

    CompanyAddress: {
      id: null,
      recUpdatedDate: null,
      recCreatedDate: null,
      recCreatedBy: null,
      recUpdatedBy: null,
      contactTypeCode: null,
      streetNumber: null,
      streetName: null,
      directionPrefix: null,
      directionSuffix: null,
      streetType: null,
      city: null,
      state: null,
      zipCode: null,
      contactName2Extn: null,
      contactName1Extn: null,
      contactName1Phone: null,
      contactName1AreaCode: null,
      contactName2AreaCode: null,
      contactName2Phone: null,
      address2: null,
      unitNumber: null,
    },
    CompanyEmail: '',
   // AdminUsers: [{ firstName: '', lastName: '', userId: '', builderId: '', email: '' }],
    BuilderMapping: [{ id: '', builderName: '', subsidiaryId: [], subsidiaryName: [], status: '' }]
  };

  // Put Call to Bulk update the lots data with  builder provided site contact details. if post call is
  // successful the list of lots is retured and updated to the table, else the error is handled by socohttp service.
  PostServiceRequest(model: RequestServiceModel[], grId: string): Observable<ApiResult<any>> {
    return this.http.put<RequestServiceModel[]>({
      url: 'Lots/PutListAsync',
      data: model,
      params: { 'grId': grId },
      shouldIgnoreInvalidResult: false,
      pleaseWaitTimeoutDuration: 2000
    });
  }

  // Update the lot data for a builder with the new values entered by the builder,if
  // successful call updates the database with the new details and swal alert is displayed to the user.
  // else the error is handled in by socohttp service.
  PostServiceRequestBylotId(model: RequestServiceModel): Observable<ApiResult<any>> {
    return this.http.put<RequestServiceModel>({
      url: 'Lots/UpdatelotByLotIdAsync',
      data: model,
      shouldIgnoreInvalidResult: false,
      pleaseWaitTimeoutDuration: 2000
    });
  }

  addAppliance(model: GasApplianceModel): Observable<ApiResult<any>> {
    return this.http.post<RequestServiceModel>({
      url: 'Lots/AddGasApplianceData',
      data: model,
      shouldIgnoreInvalidResult: false,
      pleaseWaitTimeoutDuration: 2000
    });
  }

  addUser(addUser: any): Observable<ApiResult<any>> {
    return this.http.post<BuilderInfoOne>({
      url: 'Common/AddBuilderUserAsync',
      data: addUser,
      shouldIgnoreInvalidResult: false,
      pleaseWaitTimeoutDuration: 500,
      pleaseWaitMessage: 'Processing',
      pleaseWaitContainerId: 'ContainerAwaiter2'

    });
  }

  // Gets lot details for the Builder Lot Reassignment
  GetLots(gid: number, bid: string): Observable<ApiResult<any>> {
    return this.http.get<any>({
      url: 'Lots/GetLotDetailsAsync',
      params: { 'id': gid, 'bid': bid }

    });
  }
  // To fetch address details for the selected gr id  from gasrequests selection
  Lots(gid: number): Observable<ApiResult<any>> {
    return this.http.get<any>({
      url: 'Lots/LotsAsync',
      params: { 'id': gid }

    });
  }
  // To get lots data in Service Grid
  GetLotDetails(rowValue: string): Observable<ApiResult<any>> {
    return this.http.get<any>({
      url: 'Lots/GetLotsAsync',
      params: { 'id': rowValue }
    });
  }

  getGasRequestByBcaId(id: any): Observable<ApiResult<any>> {
    return this.http.get<any>({
      url: 'Lots/GetGasRequestByBcaId',
      params: {bcaId: id},
      shouldIgnoreInvalidResult: false,
      pleaseWaitTimeoutDuration: 500,
      pleaseWaitMessage: 'Processing.',
      pleaseWaitContainerId: 'ContainerAwaiter'
    });
  }

  GetBCAStatusFromView(id: any): Observable<ApiResult<any>> {
    return this.http.get<any>({
      url: 'Lots/GetBCAStatusFromView',
      params: { bcaId: id },
      shouldIgnoreInvalidResult: false,
      pleaseWaitMessage: 'Processing.',
      pleaseWaitContainerId: 'ContainerAwaiter'
    });
  }

  getBuildingIdList(params: any): Observable<ApiResult<any>> {
    return this.http.get<any>({
      url: 'Lots/GetGISBuildingIdList',
      params: params,
      shouldIgnoreInvalidResult: false,
      pleaseWaitTimeoutDuration: 500,
      pleaseWaitMessage: 'Processing.',
      pleaseWaitContainerId: 'LocationAwaiter'
    });
  }

  getWorkRequestByBcaId(id: any): Observable<ApiResult<any>> {
    return this.http.get<any>({
      url: 'Lots/GetWorkRequestByBcaId',
      params: {bcaId: id},
      shouldIgnoreInvalidResult: false,
      pleaseWaitTimeoutDuration: 500,
      pleaseWaitMessage: 'Processing.',
      pleaseWaitContainerId: 'ContainerAwaiter'
    });
  }

  bulkAddBuildingIds(model: any, status: string): Observable<ApiResult<any[]>> {
    return this.http.post<any>({
      url: 'Lots/BulkAddBuildingIds',
      data: model,
      params: {status: status},
      shouldIgnoreInvalidResult: false,
      pleaseWaitTimeoutDuration: 500,
      pleaseWaitMessage: 'Processing.',
      pleaseWaitContainerId: 'ContainerAwaiter'
    });
  }

  bulkUpdateBuildingIds(model: any): Observable<ApiResult<any[]>> {
    return this.http.put<any>({
      url: 'Lots/BulkUpdateBuildingIds',
      data: model,
      shouldIgnoreInvalidResult: false,
      pleaseWaitTimeoutDuration: 500,
      pleaseWaitMessage: 'Processing.',
      pleaseWaitContainerId: 'ContainerAwaiter'
    });
  }

  VerifyBuilingPointExists(buildingPoint: any): Observable<ApiResult<any>> {
    return this.http.get<any>({
      url: 'Lots/VerifyBuilingPointExists',
      params: { buildingPoint: buildingPoint },
      shouldIgnoreInvalidResult: false,
      pleaseWaitTimeoutDuration: 500,
      pleaseWaitMessage: 'Processing.',
      pleaseWaitContainerId: 'ContainerAwaiter'
    });
  }

  // To Create new Additional Lots
  PostCreateLots(model: RequestServiceModel[]): Observable<ApiResult<RequestServiceModel>> {
    return this.http.post<RequestServiceModel>({
      url: 'Lots/SaveCreateLotsAsync',
      data: model,
      shouldIgnoreInvalidResult: false,
      pleaseWaitTimeoutDuration: 500
    });
  }
  // To get Builder Info for the Logged in Builder
  getBuilderInfo( companyName?: string): Observable<ApiResult<any>> {
    return this.http.get<any>({
      url: 'BuilderInfo/GetBuilderinfo',
      params: { 'builderName': companyName },
      pleaseWaitMessage: 'Processing.',
      pleaseWaitContainerId: 'ContainerAwaiter2'
    });
  }
  getBuilderDetails( companyName?: string): Observable<ApiResult<any>> {
    return this.http.get<any>({
      url: 'BuilderInfo/GetBuilderDetails',
      params: { 'builderName': companyName },
      pleaseWaitMessage: 'Processing.',
      pleaseWaitContainerId: 'ContainerAwaiter2'
    });
    }

    // add builder login audit info
    AddBuilderLoginAudit(model: BuilderLoginAuditModel): Observable<ApiResult<BuilderLoginAuditModel>> {
    return this.http.post<BuilderLoginAuditModel>({
        url: 'BuilderInfo/AddBuilderLoginAudit',
        data: model
    });
  }
  getBuilderMapping( subsidiaryId?: string): Observable<ApiResult<any>> {
    return this.http.get<any>({
      url: 'BuilderCompany/GetBuilderMapping',
      params: { 'builderId': subsidiaryId },
      pleaseWaitMessage: 'Processing.',
      pleaseWaitContainerId: 'ContainerAwaiter2'
    });
  }

  getBuilderName(builderName: string): Observable<ApiResult<any>> {
    return this.http.get<any>({
      url: 'BuilderCompany/BuilderSearch',
      params: { 'builderName': builderName },
      pleaseWaitMessage: 'Processing.',
      pleaseWaitContainerId: 'ContainerAwaiter2'
    });
  }

  // TO get SUbsidary Information for the Logged in Builder
  getSubsidiaryInfo(builderId: string[]): Observable<ApiResult<any>> {
    return this.http.get<any>({
      url: 'BuilderInfo/GetSubsidiaryInfo',
      params: { 'id': builderId }
    });
    }

    // TO get letter request summery for the Logged in Builder
    getletterInfo(builderId: string): Observable<ApiResult<any>> {
        debugger;
        return this.http.get<any>({
            url: 'Common/GetGasLetterRequestsAsync',
            params: { 'builderid': builderId }
        });
    }

  // To get the BCA's of the logged in builder and subsidaries
    getBuilderBCADetails(bcaSearch: BCASearch): Observable<ApiResult<any>> {
        return this.http.get<any>({
            url: 'GasRequest/GetBCA',
            params: bcaSearch,
            shouldIgnoreInvalidResult: false,
            pleaseWaitMessage: 'Processing.',
            pleaseWaitContainerId: 'ContainerAwaiter2'
        });
    }
  // Updates the BCA details
  editBCADetails(model: Gasbca): Observable<ApiResult<any>> {
    return this.http.put<Gasbca>({
      url: 'GasRequest/PutAsync',
      data: model,
      shouldIgnoreInvalidResult: false,
      pleaseWaitTimeoutDuration: 500,
      pleaseWaitMessage: 'Processing',
      pleaseWaitContainerId: 'ContainerAwaiter2'

    });
  }
  updateBuilderMapping(model: any): Observable<ApiResult<any>> {
    return this.http.post<any>({
      url: 'BuilderCompany/AddBuilderMappingAsync',
      data: model,
      shouldIgnoreInvalidResult: false,
      pleaseWaitTimeoutDuration: 500,
      pleaseWaitMessage: 'Processing',
      pleaseWaitContainerId: 'ContainerAwaiter2'

    });
  }
  addBuilder(model: BuilderInfoOne): Observable<ApiResult<any>> {
    return this.http.post<BuilderInfoOne>({
      url: 'BuilderCompany/AddBuilderCompanyAsync',
      data: model,
      shouldIgnoreInvalidResult: false,
      pleaseWaitTimeoutDuration: 500,
      pleaseWaitMessage: 'Processing',
      pleaseWaitContainerId: 'ContainerAwaiter2'

    });
  }
  // Submits gas Letter availability details
  postGasLetter(model: GasAvailabilityLetterModel): Observable<ApiResult<GasAvailabilityLetterModel>> {
    return this.http.post<GasAvailabilityLetterModel>({
      url: 'Common/PostGasLetterRequestAsync',
      data: model,
      shouldIgnoreInvalidResult: false,
      pleaseWaitTimeoutDuration: 500,
      pleaseWaitMessage: 'Processing.',
      pleaseWaitContainerId: 'ContainerAwaiter'
    });
  }
  // TO fetch documents in subdivision premise
  getAllFiles(id?: string): Observable<ApiResult<any>> {
    return this.http.get<any>({
      url: 'Files/GetAllDocuments',
      params: { 'id': id },
      shouldIgnoreInvalidResult: false,
      pleaseWaitTimeoutDuration: 500
    });
  }
  // To fetch agrrements data
  findFilesByMetadata(metadataParam: any): Observable<ApiResult<any>> {
    return this.http.get<any>({
      url: 'Files/GetDocumentsByMetadata',
      params: metadataParam,
      pleaseWaitTimeoutDuration: 500,
      pleaseWaitMessage: 'Processing',
      pleaseWaitContainerId: 'ContainerAwaiter'
    });
  }
  // To fetch count of agreements
  findFilesCountByMetadata(metadataParam: any): Observable<any> {
    return this.http.get<any>({
      url: 'Files/GetDocumentsCountByMetadata',
      params: metadataParam,
      pleaseWaitTimeoutDuration: 500,
      pleaseWaitMessage: 'Processing',
      pleaseWaitContainerId: 'ContainerAwaiter'
    });
  }
  // To download files in contract page
  downloadContractDocuments(metadataParam: any): Observable<any> {
    return this.http.get<any>({
      url: 'Files/GetDocumentsContract',
      params: metadataParam,
      pleaseWaitTimeoutDuration: 500
    });
  }
  // TO get gas mains data by passing gas request id as input parameter
  getMainsInfo(bcaId: number): Observable<ApiResult<any>> {
    return this.http.get<any>({
      url: 'Lots/GetMainsInfo',
      params: { 'id': bcaId }
    });
  }

  // Get Meter Info data for the MeterActivate/MeterDeActivate Form with input parameters are lot number and Gr Id.
  getMeterInfo(Id: string, grId: string): Observable<ApiResult<any[]>> {
    return this.http.get<any[]>({
      url: 'Lots/GetById',
      params: { 'id': Id, 'grid': grId }
    });
  }

  // Web api call to  add MeterActivate/MeterDeActivate request with input parameters as RequestServiceModel data and MeterActivePostModel.
  addMeter(model: MeterActivateModel, LotData: RequestServiceModel): Observable<ApiResult<MeterActivateModel>> {
    const input: MeterActivePostModel = {
      RequestData: LotData,
      MeterData: model
    };
    return this.http.post<MeterActivateModel>({
      url: 'Lots/PostAsync',
      data: input,
      shouldIgnoreInvalidResult: false,
      pleaseWaitTimeoutDuration: 500
    });
  }
  newBCA(grid: number, noOfLots: number): Observable<ApiResult<GasRequestModel>> {
    return this.http.post<GasRequestModel>({
      url: 'Applicant/GetBCAbyGrid',
      params: { 'grid': grid, 'noOfLots': noOfLots },
      shouldIgnoreInvalidResult: false,
      pleaseWaitTimeoutDuration: 500
    });
  }

  public messageSource = new BehaviorSubject<number>(0);
  GridData = this.messageSource.asObservable();

  public result = new BehaviorSubject<BuilderInfo>(this.builderInfo);
  builderData = this.result.asObservable();


  constructor(private http: SocoHttpService) {


  }
  GetGrid(passGrid: number) {
    this.messageSource.next(passGrid);
  }


}


export class MeterActivePostModel {
  RequestData: RequestServiceModel;
  MeterData: MeterActivateModel;
}
